import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormControl, makeStyles, Typography } from '@material-ui/core';
import CustomCheckbox from '../customCheckbox';
import Tooltip from '../tooltip';
import { ReactComponent as TooltipIcon } from '../../../assets/icons/tooltip.svg';
import { isObjectEmpty, isArrayEmpty } from '../../../utility/helpers';
import { ellipsis } from '../../../constants/helperCssRules';
import Scrollbars from '../scrollbars';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    width: '100%',
    paddingTop: spacing(6),
  },
  labelContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: spacing(6),
  },
  label: {
    wordBreak: 'break-word',
  },
  labelIcon: {
    width: 13,
    height: 13,
    marginLeft: spacing(1),
    cursor: 'pointer',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  checkboxRoot: {
    minHeight: 24,
    width: 'fit-content',
    maxWidth: '100%',
    '&:not(:last-of-type)': {
      marginBottom: spacing(3),
    },
  },
  checkboxLabel: {
    userSelect: 'none',
    fontSize: 14,
    maxWidth: 'calc(100% - 24px)',
    ...ellipsis(),
  },
  scrollY: {
    right: -15,
  },
  selectedViewport: {
    maxHeight: 81,
  },
}));

const CheckboxGroup = ({
customRootClass= '',
  customLabelClass = '',
  checkboxContentClass = '',
  hasScroll = false,
  label = '',
  labelHelp = {},
  checkboxItems = [],
  checkedItems = [],
  onChange,
}) => {
  const classes = useStyles();

  const renderChackboxList = () => {
    return (
      <div className={classNames(classes.content, checkboxContentClass)}>
        {checkboxItems.map(item => (
          <CustomCheckbox
            key={`checkbox_item_${item.id}`}
            customRootClass={classes.checkboxRoot}
            labelTextClass={classes.checkboxLabel}
            labelText={item.label || item.name}
            isChecked={checkedItems.includes(item.id)}
            disabled={item.isDisabled}
            onChange={() => onChange(item.id)}
          />
        ))}
      </div>
    );
  };

  return (
    <FormControl className={classNames(classes.root, customRootClass)}>
      {label && (
        <div className={classes.labelContainer}>
          <Typography
            variant="subtitle1"
            className={classNames(classes.label, customLabelClass)}
          >
            {label}
          </Typography>
          {!isObjectEmpty(labelHelp) && (
            <Tooltip
              customIconClass={classes.labelIcon}
              text={labelHelp.tooltipText}
              icon={TooltipIcon}
            />
          )}
        </div>
      )}
      {hasScroll && !isArrayEmpty(checkboxItems) ? (
        <Scrollbars
          viewportClass={classes.selectedViewport}
          verticalScrollClass={classes.scrollY}
        >
          <div>{renderChackboxList()}</div>
        </Scrollbars>
      ) : (
        renderChackboxList()
      )}
    </FormControl>
  );
};

CheckboxGroup.propTypes = {
  customRootClass: PropTypes.string,
  customLabelClass: PropTypes.string,
  label: PropTypes.string,
  labelHelp: PropTypes.shape({}),
  checkboxItems: PropTypes.arrayOf(PropTypes.shape({})),
  checkboxContentClass: PropTypes.string,
  checkedItems: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  onChange: PropTypes.func.isRequired,
  hasScroll: PropTypes.bool,
};

export default CheckboxGroup;
